import React from 'react'
import { Box, Drawer, DrawerProps, SwipeableDrawer } from '@mui/material'
import { usePreventReloadOnWebview } from 'src/Libs/navigation/hooks/use-prevent-reload-on-webview'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme, props) => ({
  drawerPaper: {
    '& .MuiDrawer-paper': {
      background: theme.palette.common.white,
      borderRadius: theme.shape.mobileDrawer.borderRadius,
      margin: 0,
      top: theme.spacing(3),
      display: 'flex',
      flex: 1,
      position: 'absolute',
      overflow: 'hidden',
      width: '100%',
      paddingBottom: theme.spacing(2),
    },
  },
  notClosableDrawer: {
    '& .MuiDrawer-paper': {
      paddingTop: theme.spacing(3),
    },
  },
  barContainer: {
    margin: theme.spacing(2),
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    color: 'white',
  },
  bar: {
    margin: 'auto',
    width: '100px',
    height: '4px',
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.grey.grey05,
  },
}))

interface Props {
  onClose: () => void
  open: boolean
  containerStyle?: string
  barStyle?: string
  children?: React.ReactNode
  closableOnlyWithActionButtons?: boolean
  anchor?: DrawerProps['anchor']
}

/**
 * A mobile drawer which takes almost full height per default and lays on top of all other content.
 * Prevents reloading issues on android by using the so named hook.
 */
const MobileDrawer: React.FC<Props> = ({ open, onClose, containerStyle, barStyle, children, closableOnlyWithActionButtons = false, anchor }) => {
  const { classes, cx } = useStyles()
  usePreventReloadOnWebview(open)

  if (closableOnlyWithActionButtons)
    return (
      <Drawer anchor={anchor} open={open} className={cx(classes.drawerPaper, classes.notClosableDrawer, containerStyle)}>
        {children}
      </Drawer>
    )

  return (
    <SwipeableDrawer anchor="bottom" onClose={onClose} onOpen={() => undefined} open={open} className={cx(classes.drawerPaper, containerStyle)}>
      <Box className={classes.barContainer}>
        <Box className={cx(classes.bar, barStyle)} />
      </Box>
      {children}
    </SwipeableDrawer>
  )
}

export default MobileDrawer
